import { useContext } from 'react'
import { ProfileContext } from './ProfileContextDef'

export function useProfileContext() {
  const context = useContext(ProfileContext)
  if (context === undefined) {
    throw new Error('useProfileContext must be used within a ProfileProvider')
  }
  return context
}
